export default __webpack_public_path__ + "static/media/steps-icon.b3262cdb.svg";